import { APP_INITIALIZER, ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { MarkdownModule } from 'ngx-markdown';
import { FuseModule } from '@fuse';
import { FuseConfigModule } from '@fuse/services/config';
import { FuseMockApiModule } from '@fuse/lib/mock-api';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { mockApiServices } from 'app/mock-api';
import { LayoutModule } from 'app/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { UserModule } from './features/featureTest/components/user/user.module';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { appReducers } from './_store/app.reducer';
import { LicenseManager } from 'ag-grid-enterprise';
import { provideHotToastConfig } from '@ngxpert/hot-toast';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpErrorInterceptor } from 'app/shared/classes/http-error.interceptor';
import { NotFoundErrorHandler } from './shared/not-found-error-handler';
import { MAT_DATE_LOCALE } from "@angular/material/core";
import { NavigationSyncService } from './core/navigation/navigation-sync.service';


const routerConfig: ExtraOptions = {
  preloadingStrategy: PreloadAllModules,
  scrollPositionRestoration: 'enabled'
};

// Register French locale data for pipes and formatDate
registerLocaleData(localeFr);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes, routerConfig),

    // Fuse, FuseConfig & FuseMockAPI
    FuseModule,
    FuseConfigModule.forRoot(appConfig),
    FuseMockApiModule.forRoot(mockApiServices),
    StoreModule.forRoot(appReducers),
    EffectsModule.forRoot(),
    StoreDevtoolsModule.instrument({
      maxAge: 25 // Conserve les 25 dernières actions
    }),

    // Core module of your application
    CoreModule,

    // Layout module of your application
    LayoutModule,

    // 3rd party modules that require global configuration via forRoot
    MarkdownModule.forRoot({}),    
    UserModule
  ],
  bootstrap: [AppComponent],
  providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' }, // affichage de la date en format :  JJ/MM/AAAA
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: ErrorHandler, useClass: NotFoundErrorHandler },
    provideHotToastConfig({
      reverseOrder: true,
      dismissible: true,
      autoClose: true,
      position: 'bottom-center',
      duration: 4000,
      theme: 'snackbar'
    })
     ,
    {
      provide: APP_INITIALIZER,
      useFactory: (sync: NavigationSyncService) => () => sync.init(),
      deps: [NavigationSyncService],
      multi: true
    }
  ]
})
export class AppModule {
  constructor() {
    LicenseManager.setLicenseKey(
      'Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-071261}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{ACE_Energie}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{TERA}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{TERA}_need_to_be_licensed___{TERA}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{8_November_2025}____[v3]_[0102]_MTc2MjU2MDAwMDAwMA==ba4a4fd4caaf67dd62aaa9624f6bf9d1'
    );
  }
}
